<template>
  <div id="the-story">
    <div class="story-container">
      <b-container class="story-container-inner">
        <h1>The Story</h1>
        <div class="separator" />
        <p class="no-margin">
          The Chicago Cubs have teamed up with multidisciplinary artist and
          Chicago native, Louis De Guzman, on a collaboration that celebrates
          Chicago's vibrant culture, champions the city's talented community of
          artists and engages the next generation of fans. For the
          collaboration, De Guzman created a sculpture titled “COHERE” which is
          a dynamic reinterpretation of the Cubs' “Angry Bear” logo crafted from
          electroplated bronze, a reflective material which allows the viewer to
          physically see themselves in the art as a way to emphasize a sense of
          community and connection among the viewers. “COHERE” was constructed
          by purposely joining multiple pieces of metal together to depict the
          binding of community and connection Chicagoans feel toward one
          another, their city and their team.
          <br /><br />
          As part of the collaboration, De Guzman also created a limited-edition
          merchandise collection for fans to purchase, including a short-sleeve
          pocket T-shirt, a pullover hoodie and miniature versions of the
          “COHERE” sculpture.
        </p>
      </b-container>
      <img
        class="sculpture"
        src="@/assets/images/artistshome/deguzman/cubs-sculpture.png"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "TheStory",
  computed: {
    ...mapState(["global"]),
  },
};
</script>

<style lang="scss" scoped>
$video-width: calc((100vh - 100px) * 1.778);

#the-story {
  position: relative;
  padding-left: 19px;
  padding-right: 19px;
  margin-bottom: 275px;
  @media (max-width: $md) {
    padding-left: 0;
    padding-right: 0;
    padding-bottom: 50px;
  }
  .story-container {
    display: flex;
    background-image: url("~@/assets/images/bg/Texture.png");
    background-repeat: no-repeat;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    background-position: center;
    padding-bottom: 100px;
  }
  .story-container-inner {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding-top: 93px;
    padding-bottom: 108px;
    padding-left: 15px;
    padding-right: 15px;

    @media (max-width: $md) {
      padding-left: 20px;
      padding-right: 20px;
      padding-top: 48px;
      padding-bottom: 44px;
    }
    h1 {
      font-family: Poppins-Bold;
      font-size: 34px;
      color: #ffffff;
      letter-spacing: 0;
      text-align: center;
      line-height: 42px;
      text-transform: uppercase;
    }
    .separator {
      width: 115px;
      height: 4px;
      background: #eaeaea;
      margin-top: 15px;
      margin-bottom: 15px;
    }
    p {
      width: 852px;
      max-width: 100%;
      font-family: AvenirNext-Medium;
      font-size: 18px;
      color: #ffffff;
      text-align: center;
      line-height: 31px;
      margin-top: 60px;
      width: 750px;
    }
    .no-margin {
      margin: 0 !important;
      width: 750px;
      max-width: 100%;
    }
  }
  .sculpture {
    position: absolute;
    bottom: -260px;
    left: 50%;
    transform: translateX(-50%);
    height: 422px;
    max-width: 100%;
    object-fit: contain;
  }
}
</style>

